import { Text } from '@radix-ui/themes'

interface CellTextProps {
  value: string | number | null | undefined
  mono?: boolean
}

// A table cell's value, or a muted em-dash when there isn't one.
export const CellText = ({ value, mono = false }: CellTextProps) =>
  value === null || value === undefined || value === '' ? (
    <Text size="1" color="gray">
      —
    </Text>
  ) : (
    <Text size="2" className={mono ? 'font-mono' : undefined}>
      {value}
    </Text>
  )
